import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import CardMedia from "@material-ui/core/CardMedia";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";

class PrincipalEdit extends Component {
	state = {
		data: ""
	};

	componentDidMount() {
		this.state = {
			data: this.props.info,
			modal: false
		};
	}

	handleConfirm = () => {
		this.props.handleDelete({ id: this.props.id }, this.props.token);
	};

	handleCancel = () => {
		this.setState({
			modal: false
		});
	};

	openModal = () => {
		console.log("OPENM MODAL");
		this.setState({
			modal: true
		});
	};
	render() {
		return (
			<React.Fragment>
				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.modal}
				>
					<Paper
						style={{
							display: "grid",
							width: "30%",
							padding: "50px",
							margin: "20% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Desea Borrar?
							<br />
							<br />
							<br />
							<Button
								onClick={this.handleConfirm}
								type="submit"
								color="secondary"
								variant="contained"
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button
								onClick={this.handleCancel}
								color="primary"
								variant="contained"
							>
								Cancelar
							</Button>
						</div>
					</Paper>
				</Modal>

				<Card style={{ width: "100%", marginBottom: 10 }}>
					<CardContent>
						<TextField
							id="outlined-basic"
							label="Titulo"
							variant="outlined"
							value={this.props.titulo}
							style={{ width: "90%" }}
						/>
						<br />
						<br />
						<TextField
							id="outlined-basic"
							label="Descripción"
							variant="outlined"
							multiline
							value={this.props.descripcion}
							style={{ width: "90%" }}
						/>
						<br />
						<br />
						<TextField
							id="outlined-basic"
							label="Sección"
							variant="outlined"
							multiline
							value={this.props.seccion}
							style={{ width: "90%" }}
						/>
						<br />
						<br />
						<TextField
									id="outlined-basic"
									label="Link"
									variant="outlined"
									multiline
									value={this.props.link}
									style={{ width: "90%" }}
								/> 
						<br />
						<br />		
						<CardMedia
							image={this.props.imagen}
							title="Imagen"
							style={{ width: "200px", height: "200px", marginLeft: "5%" }}
						/>
					</CardContent>

					<CardActions>
						<Button
							color="secondary"
							onClick={() => {
								this.openModal();
							}}
						>
							Borrar
						</Button>
					</CardActions>
				</Card>
			</React.Fragment>
		);
	}
}
export default PrincipalEdit;
